import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'material',
    lazy: async () => ({ Component: (await import('./MaterialPage')).MaterialPage }),
  },
];
